import { defineAsyncComponent } from 'vue';

// @ts-ignore - vue-tsc complains about the import, but it works
export const ErrorList = defineAsyncComponent(() => import('./ErrorList.vue'));
